module.exports = __webpack_public_path__ + "static/media/icon-distribution.2094893b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon-distribution.svg
// module id = 390
// module chunks = 0